import { ProductSelectEvent } from '@shopify/events';

class StarkInstallationService extends HTMLElement {
  connectedCallback() {
    this.scope = this.closest('.shopify-section') || document;
    this.handleChange = this.handleChange.bind(this);
    this.handleProductSelect = this.handleProductSelect.bind(this);
    this.selectionGeneration = 0;
    this.scope.addEventListener('change', this.handleChange);
    this.scope.addEventListener(ProductSelectEvent.eventName, this.handleProductSelect);
    this.update();
  }

  disconnectedCallback() {
    this.scope?.removeEventListener('change', this.handleChange);
    this.scope?.removeEventListener(ProductSelectEvent.eventName, this.handleProductSelect);
  }

  handleChange(event) {
    if (event.target.closest('variant-picker')) this.update(false);
  }

  async handleProductSelect(event) {
    const picker = event.target?.closest('variant-picker');

    if (!picker || picker.dataset.productId !== this.dataset.productId) return;

    const generation = ++this.selectionGeneration;

    try {
      await event.promise;
    } catch (error) {
      if (error?.name !== 'AbortError') console.error(error);
      return;
    }

    if (generation === this.selectionGeneration) this.update();
  }

  update(allowZoneReset = true) {
    const productId = this.dataset.productId;
    const picker = this.scope.querySelector(`variant-picker[data-product-id="${productId}"]`);
    const legacyZoneContainer = this.querySelector('[data-installation-zone]');
    const legacyZoneSelect = this.querySelector('select');

    if (!picker) return;

    const selectedValues = [
      ...Array.from(picker.querySelectorAll('fieldset input:checked')).map((input) => input.value),
      ...Array.from(picker.querySelectorAll('select')).map((select) => select.value),
    ];
    const keyword = this.normalize(this.dataset.installationKeyword || 'Con instalación');
    const installationSelected = selectedValues.some((value) => this.normalize(value).includes(keyword));

    if (this.dataset.nativeZoneOption === 'true') {
      this.updateNativeZone(picker, installationSelected, allowZoneReset);
      return;
    }

    if (!legacyZoneContainer || !legacyZoneSelect) return;

    legacyZoneContainer.hidden = !installationSelected;
    legacyZoneSelect.disabled = !installationSelected;
    legacyZoneSelect.required = installationSelected;

    if (!installationSelected) legacyZoneSelect.value = '';
  }

  updateNativeZone(picker, installationSelected, allowZoneReset) {
    const zoneOptionName = this.normalize(this.dataset.zoneOptionName || 'Zona de instalación');
    const noZoneValue = this.normalize(this.dataset.noZoneValue || 'No aplica');
    const zoneControls = Array.from(picker.querySelectorAll('[data-option-name]')).filter(
      (control) => this.normalize(control.dataset.optionName || '') === zoneOptionName
    );
    const zoneContainer = zoneControls[0]?.closest('.variant-option');

    if (!zoneContainer) return;

    zoneContainer.toggleAttribute('data-installation-zone-hidden', !installationSelected);

    for (const control of zoneControls) {
      const controlValue = control instanceof HTMLOptionElement ? control.value : control.value;
      const isNoZoneControl = this.normalize(controlValue) === noZoneValue;
      const visibleControl = control instanceof HTMLOptionElement ? control : control.closest('label');

      visibleControl?.toggleAttribute('data-installation-no-zone-hidden', installationSelected && isNoZoneControl);

      if (allowZoneReset && !installationSelected && isNoZoneControl && !control.checked && !control.selected) {
        if (control instanceof HTMLOptionElement) {
          const select = control.closest('select');
          if (select) {
            select.value = control.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        } else {
          control.click();
        }
      }
    }
  }

  normalize(value) {
    return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('es');
  }
}

if (!customElements.get('stark-installation-service')) {
  customElements.define('stark-installation-service', StarkInstallationService);
}
